import { getRootStore } from 'satcheljs';
import { type OwaWorkload } from 'owa-workloads';
import { when } from 'mobx';

/**
 * Wait for calendar strings to be loaded
 * We don't load strings until explicit access. Access "dateWeekDayLong" to trigger loading
 */
export const waitForCalendarStrings = (workload: OwaWorkload) => {
    if (workload === 2) {
        return when(() =>
            getRootStore()
                .get('locstrings')
                .registeredStringModules.get('owa-mini-common-strings')
                ?.strings.get('dateWeekDayLong')
        );
    }

    return Promise.resolve();
};
